export const ROUTES = {
  HOME: '/',
  AUTH: '/auth',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  PROFILE: '/profile',
  COURSES: '/courses',
  FAVORITES: '/favorites',
  SUBSCRIBE: '/subscribe',
  CARD: (cardId: string | number = ':cardId') => `/card/${cardId}`,
  COURSE_DETAIL: (courseId: string | number = ':courseId') => `/courses/${courseId}`,
  LESSON: (courseId: string | number = ':courseId', lessonId: string | number = ':lessonId') =>
    `/courses/${courseId}/lesson/${lessonId}`,
  CALCULATOR: (cardId: string | number = ':cardId?') => `/calculator/${cardId}`,
  LINK_TELEGRAM_CONFIRM: '/link-telegram/confirm'
} as const
